import { GET_UNIT_OF_MEASURE_LIST } from '../actions/types';

const initialState = {
  list: []
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_UNIT_OF_MEASURE_LIST: {
      return { ...state, ...{ list: action.unitOfMeasureData } };
    }
    default:
      return state;
  }
}
